// Action Types
export const actionTypes = {
  GET_UNIT_DETAILS: "GET_UNIT_DETAILS",
  GET_UNIT_DETAILS_SUCCESS: "GET_UNIT_DETAILS_SUCCESS",
  GET_UNIT_DETAILS_FAILED: "GET_UNIT_DETAILS_FAILED",

  CALCULATE_FINISH: "CALCULATE_FINISH"

  // GET_PAYMENT_SCHEMES: "GET_PAYMENT_SCHEMES",
  // GET_PAYMENT_SCHEMES_SUCCESS: "GET_PAYMENT_SCHEMES_SUCCESS",
  // GET_PAYMENT_SCHEMES_FAILED: "GET_PAYMENT_SCHEMES_FAILED"
};

// Action creators
export const actionCreators = {
  getUnitDetails: params => ({
    type: actionTypes.GET_UNIT_DETAILS,
    params
  }),
  calculateFinish: params => ({
    type: actionTypes.CALCULATE_FINISH,
    params
  })
};

// Reducer
const initialState = {
  isLoading: false,
  data: null,
  paymentSchemes: [],
  calculatedValues: {
    selectedCurrency: "usd",
    selectedScheme: "95(1)/0(0)/5(1)",
    selectedCloseFeeScheme: "installment",
    selectedDiscounts: []
  },
  errors: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_UNIT_DETAILS:
      return Object.assign({}, state, {
        data: null,
        isLoading: true,
        errors: null
      });

    case actionTypes.GET_UNIT_DETAILS_FAILED:
      return Object.assign({}, state, {
        isLoading: true,
        errors: action.errors
      });

    case actionTypes.GET_UNIT_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: true,
        data: action.payload,
        paymentSchemes: action.paymentSchemes
      });

    case actionTypes.CALCULATE_FINISH:
      return Object.assign({}, state, {
        calculatedValues: action.params
      });

    default:
      return state;
  }
};
